// 引入组件
import ErrorDialog from './Error'
ErrorDialog.install = Vue => Vue.component(ErrorDialog.name, ErrorDialog);

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(ErrorDialog);
}

export default ErrorDialog


// WEBPACK FOOTER //
// ./src/packages/dialogs/Error_index.js